// Static product data (temporary until Next.js migration)
export const PRODUCT_DATA = {
  id: '1',
  name: 'ClearWay Smart Walking Stick',
  short_description: 'Smart Mobility. Real Confidence.',
  long_description: 'A fully integrated smart mobility stick designed to help visually impaired and elderly users move more safely and confidently. Features advanced sensors for forward obstacle detection, downward-facing surface sensing to identify potholes and drops, Apple Find My support for easy location tracking, and reliable power without complex rechargeable batteries.',
  price_inr: 6999,
  compare_at_price_inr: 9999,
  // Empty so ShopPage falls back to its richer 6-image gallery
  // (studio shots, in-use, and outdoor shots) instead of a single photo.
  image_urls: [],
  active: true,
  in_stock: true
};

export const SHIPPING_RATES = {
  'India': 999,
  'United Arab Emirates': 2999
};

// Coupons are validated server-side only (/api/coupon/validate).
// Never ship coupon codes or discount logic in the client bundle.
